(function () {
  const THRESHOLD = 800000;
  const EXCLUDE_TAG = "送料無料適応外";

  // 商品のタグをキャッシュ（ページ内で重複リクエストを防ぐ）
  const tagCache = {};

  function getProductTags(handle) {
    if (tagCache[handle] !== undefined) {
      return Promise.resolve(tagCache[handle]);
    }
    return fetch(`/products/${handle}.js`)
      .then((res) => res.json())
      .then((product) => {
        tagCache[handle] = product.tags || [];
        return tagCache[handle];
      });
  }

  function updateBar(eligibleCents) {
    const bar = document.getElementById("free-shipping-bar");
    if (!bar) return;

    const remainingCents = Math.max(0, THRESHOLD - eligibleCents);
    const progress = Math.min(
      100,
      Math.round((eligibleCents / THRESHOLD) * 100),
    );
    const fill = bar.querySelector(".free-shipping-bar__fill");
    const msg = bar.querySelector(".free-shipping-bar__message");

    if (!fill || !msg) return;

    fill.style.width = progress + "%";

    if (remainingCents <= 0) {
      msg.innerHTML = "送料無料が適用されました！";
      msg.classList.add("free-shipping-bar__message--achieved");
      fill.classList.add("free-shipping-bar__fill--achieved");
    } else {
      const remainingYen = Math.ceil(remainingCents / 100);
      const formatted = remainingYen.toLocaleString("ja-JP");
      msg.innerHTML = `あと <strong>¥${formatted}</strong> で送料無料！`;
      msg.classList.remove("free-shipping-bar__message--achieved");
      fill.classList.remove("free-shipping-bar__fill--achieved");
    }
  }

  function fetchCartAndUpdate() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        // 全アイテムのタグを並行取得
        const promises = cart.items.map((item) =>
          getProductTags(item.handle).then((tags) => ({
            line_price: item.line_price,
            excluded: tags.includes(EXCLUDE_TAG),
          })),
        );

        return Promise.all(promises);
      })
      .then((items) => {
        const eligibleCents = items
          .filter((item) => !item.excluded)
          .reduce((sum, item) => sum + item.line_price, 0);

        updateBar(eligibleCents);
      });
  }

  function observeCart() {
    const target = document.querySelector(
      "cart-items, .cart__items, #cart-form",
    );
    if (!target) return;
    const observer = new MutationObserver(() => {
      fetchCartAndUpdate();
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", () => {
    fetchCartAndUpdate();
    observeCart();
  });

  document.addEventListener("cart:updated", fetchCartAndUpdate);
})();
